export const environment = {
  production: true,
  baseUrl: null,
  demo: false,
  ga: '',
  plausible: null,
  titlePrefix: 'ThomisticInstitute',
  minutesBeforeTimeOut: 15,
  homeUrl: '',
  features: {
    timeEntriesActualTime: true,
  },
  sentryDsn: null as string | null,
  environmentName: 'default',
};
